module.exports = __webpack_public_path__ + "9bf5c5bb4409b61082b2607dc4184846.svg";